import { isEmpty, last } from 'lodash';
import { useMemo } from 'react';

import { AppointmentModalData } from '../../../data/data/types';
import {
  AgendaBlockItemDataFragment,
  AgendaSlotItemDataFragment,
  SlotType,
} from '../../../data/types/api/graphql';
import { CustomFormattedMessage } from '../../../elements/intl/custom-formatted-message';
import { AgendaAppointmentSlotListItem } from './agenda-appointment-slot-list-item';

type AgendaAppointmentSlotListProps = {
  healthProviderId: string | null | undefined;
  healthProfessionalId: string | null | undefined;
  agendaBlockItem: AgendaBlockItemDataFragment;
  compact?: boolean;
  showAppointmentModal?: (
    slotType: SlotType,
    value: AppointmentModalData | null
  ) => void;
};

export function AgendaAppointmentSlotList({
  healthProviderId,
  healthProfessionalId,
  agendaBlockItem,
  compact,
  showAppointmentModal,
}: AgendaAppointmentSlotListProps) {
  const items = useMemo(() => agendaBlockItem.slots, [agendaBlockItem.slots]);

  const getKey = (option: AgendaSlotItemDataFragment) => {
    const lastAppointment =
      option.appointments.length > 0 ? last(option.appointments) : null;

    return `appointment-slot-list-item-${option.id}-${
      lastAppointment?.id ?? ''
    }`;
  };

  if (isEmpty(items)) {
    return (
      <p>
        <CustomFormattedMessage id="common.no-data" />
      </p>
    );
  }

  return (
    <div className="content-list">
      {items.map(option => (
        <div
          key={getKey(option)}
          className={`content-list__item${compact ? '--compact' : ''}`}
        >
          <AgendaAppointmentSlotListItem
            showAppointmentModal={showAppointmentModal}
            compact={compact}
            healthProviderId={healthProviderId}
            healthProfessionalId={healthProfessionalId}
            agendaBlockItem={agendaBlockItem}
            agendaSlotItem={option}
          />
        </div>
      ))}
    </div>
  );
}
